import { Box, GridItem, Link, Text } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { RanaHeading } from "@nens/ranalib";

import { DASHBOARD_GRID_ITEM_HEIGHT } from "@/features/tenant";

import { ContentPanel } from "./content-panel";

// Subject and body for the email template
const SUBJECT = "Vraag over Rana";
const BODY = `Hallo Rana Support,

Vraag: [uw vraag]
Projectnaam: [naam van het project]
Categorie: [kies een van de volgende categorieën waar uw vraag in valt: Autorisation, authentication, user onboarding, projects, file management, Desktop client, processes, publications, data lineage of usage & billing]
Error Code: [de foutmelding]
Besturingssysteem: [Uw besturingssysteem]
Browserversie: [versie van uw webbrowser]
Screenshots en schermopnamen: [voeg screenshots of schermopnames toe in de bijlage die duidelijk laten zien welke stappen u doorloopt waardoor het probleem voorkomt.]

Met vriendelijke groet,
[uw naam]`;

// Encode the subject and body for the email template
const ENCODED_SUBJECT = encodeURIComponent(SUBJECT);
const ENCODED_BODY = encodeURIComponent(BODY);

export function ImproveRanaOverviewBlock() {
  return (
    <GridItem height={DASHBOARD_GRID_ITEM_HEIGHT}>
      <ContentPanel bg="brand.gradient.light">
        <Box>
          <RanaHeading type="h6" pb={4}>
            <FormattedMessage
              id="blocktitle.missing_something"
              defaultMessage="Are you missing something or experiencing {br} any issues?"
              values={{ br: <br /> }}
            />
          </RanaHeading>
          <Text lineHeight={4} pb={4}>
            <FormattedMessage
              id="block.share_your_feedback"
              defaultMessage="Check out the {user_manual} for a step-by-step guide"
              values={{
                user_manual: (
                  <Link
                    textDecor="underline"
                    isExternal
                    href="https://docs.ranawaterintelligence.com/"
                    fontWeight="semibold"
                  >
                    <FormattedMessage id="block.user_manual" defaultMessage="user manual" />
                  </Link>
                ),
              }}
            />
          </Text>
          <Text lineHeight={4} fontWeight="semibold">
            <FormattedMessage
              id="block.still_stuck"
              defaultMessage="Still stuck or missing something?"
            />
          </Text>
          <Text lineHeight={4} pb={4}>
            <FormattedMessage
              id="block.looking_to_improve"
              defaultMessage="We are always looking to improve &mdash; feel free to share your {br} feedback or questions by emailing Linda"
              values={{ br: <br /> }}
            />
          </Text>
          <Link
            lineHeight={4}
            textDecor="underline"
            href={`mailto:support@ranawaterintelligence.com?subject=${ENCODED_SUBJECT}&body=${ENCODED_BODY}`}
            fontWeight="semibold"
          >
            support@ranawaterintelligence.com
          </Link>
        </Box>
      </ContentPanel>
    </GridItem>
  );
}
